
    <p-checkbox
      pInputCheckbox
      binary="true"
      (onChange)="onChange($event)"
      [ngModel]="isSelected()"
      [hidden]="isSummary()"
    ></p-checkbox>
  